import { writeToClipboard } from './clipboardUtils';

export const replaceLicenses = (oldLics, newLics) => [
  ...oldLics.map((oldLic) => {
    const foundNewLic = newLics.find((newLic) => newLic.id === oldLic.id);
    return foundNewLic === undefined ? oldLic : foundNewLic;
  }),
  ...newLics.filter(
    (newLic) => oldLics.find((oldLic) => oldLic.id === newLic.id) === undefined
  ),
];

export const copyLicenseKeysToMemory = (licenses) => () => {
  const data = licenses.map((license) => license.key);
  writeToClipboard(data.join("\n"))();
};



// WEBPACK FOOTER //
// ./src/common/licenseUtils.js